import { render, staticRenderFns } from "./MyLoading.vue?vue&type=template&id=40f9193d"
import script from "./MyLoading.vue?vue&type=script&lang=js"
export * from "./MyLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports